import React, { useState } from "react";
import Comment from "./Comment";

const OwnersReviews = ({data, resourceUrl, totalPages}) => {
  const [page, setPage] = useState(1);
  const [reviews, setReviews] = useState(data);
  const url = resourceUrl;

  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json'

  const handleSubmit = e => {
    e.preventDefault();

    axios.get(url, {
      params: { page: page + 1 }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      setReviews([...reviews, ...response.data]);
      setPage(page + 1);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  return (
    <div>
      <div className="reviews__wrapper">
        {data.map((element, index) => (
          <Comment
            key={index}
            date={element.date}
            name={element.name}
            doctor={element.doctor}
            text={element.text}
          />
        ))}
      </div>
      {page < totalPages &&
        <span className="reviews-button-animation-container animation-waypoint animation-trigger">
          <a className="button button_large reviews__button" onClick={handleSubmit} rel="next">Еще 20 отзывов</a>
        </span>
      }
    </div>
  )

};

export default OwnersReviews;
